import { useState } from 'react';
import {
  ExpandLess,
  ExpandMore,
  PlayArrow,
  StarBorderRounded,
  StarRounded,
} from '@mui/icons-material';
import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip,
} from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useFavorites } from 'hooks/useFavorites';

const activeIndicatorSx = {
  fontSize: '12px !important',
  color: '#FF3D03',
  ml: 'auto',
  flexShrink: 0,
};

function MenuItem({
  title,
  route,
  icon,
  onClick,
  hidden,
  children,
  collapsed = false,
  forceOpen = false,
}) {
  const [open, setOpen] = useState(false);
  const { favorites, toggleFavorite } = useFavorites();

  const handleClick = (onClick, route) => {
    if (!route) setOpen(!open);
    if (onClick) onClick();
  };

  // ----- Modo colapsado (etapa 2): apenas ícone, centralizado -----
  if (collapsed) {
    if (hidden) return null;

    const renderIconButton = (isActive = false) => (
      <Tooltip title={title} placement='right' arrow>
        <ListItemButton
          selected={isActive && route !== undefined}
          onClick={() => handleClick(onClick, route)}
          sx={{
            justifyContent: 'center',
            px: 0,
            minHeight: 32,
            '& .MuiListItemIcon-root': { marginRight: 0 },
          }}
        >
          <ListItemIcon>{icon}</ListItemIcon>
        </ListItemButton>
      </Tooltip>
    );

    return (
      <ListItem dense disablePadding>
        {route ? (
          <NavLink to={route} style={{ width: '100%' }}>
            {({ isActive }) => renderIconButton(isActive)}
          </NavLink>
        ) : (
          <div style={{ width: '100%' }}>{renderIconButton()}</div>
        )}
      </ListItem>
    );
  }

  const renderButton = (isActive = false) => (
    <ListItemButton
      selected={isActive && route !== undefined}
      className={children ? 'has-children' : 'top-level'}
      onClick={() => handleClick(onClick, route)}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={title} primaryTypographyProps={{ noWrap: true }} />
      {children ? (
        open || forceOpen ? (
          <ExpandLess />
        ) : (
          <ExpandMore />
        )
      ) : (
        isActive && route && <PlayArrow sx={activeIndicatorSx} />
      )}
    </ListItemButton>
  );

  return (
    <>
      {!hidden && (
        <ListItem dense disablePadding>
          {route ? (
            <NavLink to={route} style={{ width: '100%' }}>
              {({ isActive }) => renderButton(isActive)}
            </NavLink>
          ) : (
            <div style={{ width: '100%' }}>{renderButton()}</div>
          )}
        </ListItem>
      )}
      {!hidden && children && (
        <Collapse in={open || forceOpen} timeout='auto' unmountOnExit>
          <List dense disablePadding>
            {children.map((child, index) => {
              if (child.hidden) return null;
              const isFavorite = favorites.includes(child.route);

              return (
                <NavLink to={child.route} key={index}>
                  {({ isActive }) => (
                    <ListItemButton
                      selected={isActive}
                      id={
                        child.route
                          ? child.route.substring(1)
                          : `child-${index}`
                      }
                      onClick={() => handleClick(child.onClick, child.route)}
                      sx={{
                        '&:hover .favorite-toggle, &:focus-within .favorite-toggle':
                          { opacity: 1 },
                        ...(isFavorite && {
                          '& .favorite-toggle .MuiSvgIcon-root': {
                            color: '#FF3D03',
                          },
                        }),
                      }}
                    >
                      <ListItemText
                        inset
                        primary={child.title}
                        primaryTypographyProps={{ noWrap: true }}
                      />
                      {child.route && (
                        <Tooltip
                          title={
                            isFavorite
                              ? 'Remover dos favoritos'
                              : 'Adicionar aos favoritos'
                          }
                        >
                          <IconButton
                            size='small'
                            className='favorite-toggle'
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              toggleFavorite(child.route);
                            }}
                            sx={{
                              p: 0,
                              flexShrink: 0,
                              opacity: isFavorite ? 1 : 0,
                            }}
                          >
                            {isFavorite ? (
                              <StarRounded fontSize='small' />
                            ) : (
                              <StarBorderRounded fontSize='small' />
                            )}
                          </IconButton>
                        </Tooltip>
                      )}
                      {isActive && <PlayArrow sx={activeIndicatorSx} />}
                    </ListItemButton>
                  )}
                </NavLink>
              );
            })}
          </List>
        </Collapse>
      )}
    </>
  );
}
export default MenuItem;
